import React from 'react';
import clsx from 'clsx';

import { cloudinaryUrl } from '@/utils/utils';
import styles from './avatar.module.css';

export type AvatarProps = {
  prenom: string,
  nom: string,
  size: 60 | 110,
  photo?: string,
  className?: string
}

export const Avatar = ({ size, photo, prenom, nom, className, ...props }: AvatarProps)=> {

  return (
    <div className={clsx(className)} {...props}>
      { photo ? (
        <img
          className={styles.photo}
          width={size} height={size}
          src={cloudinaryUrl({src: photo, width: `${size}`, params: [`h_${size}`]})}
          srcSet={`
            ${cloudinaryUrl({src: photo, width: `${size}`, params: [`h_${size}`]})} 1x,
            ${cloudinaryUrl({src: photo, width: `${size * 2}`, params: [`h_${size * 2}`]})} 2x`}
          alt={`${prenom} ${nom}`} />
        ) : <span className={clsx(styles.photo, styles.placeholder)} style={{'--size': size}  as React.CSSProperties}>{prenom[0].toUpperCase()}{nom[0].toUpperCase()}</span>
      }
    </div>
  )
};
